module.exports = __webpack_public_path__ + "static/media/Quicksand-Medium.54a1d8fd.woff";